import type { ReactNode } from "react";

export function Card({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`bg-white dark:bg-surface-2 border border-slate-200 dark:border-white/10 rounded-xl shadow-soft ${className}`}>{children}</div>;
}
